var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-3 card mb-3"},[_c('FccDescricaoDasOpcoes',{attrs:{"vagas-reservadas":_vm.listaVagasReservadas},on:{"importar":_vm.importar}}),_c('FccAlteracoesVagasReservadas',{attrs:{"alteracoes":_vm.alteracoes}})],1),_c('fccLocalDeProvaStatus',{attrs:{"etapa":_vm.etapa}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }